import { render, staticRenderFns } from "./EmpleadosNuevo.vue?vue&type=template&id=2751eb00&"
import script from "./EmpleadosNuevo.vue?vue&type=script&lang=js&"
export * from "./EmpleadosNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports